import { render, staticRenderFns } from "./un_owner.vue?vue&type=template&id=41abc86c&scoped=true&"
import script from "./un_owner.vue?vue&type=script&lang=js&"
export * from "./un_owner.vue?vue&type=script&lang=js&"
import style0 from "./un_owner.vue?vue&type=style&index=0&id=41abc86c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41abc86c",
  null
  
)

component.options.__file = "un_owner.vue"
export default component.exports